import produce from "immer";
import {
  GET_REPORTS_LIST,
  GET_REPORTS_LIST_SUCCESS,
  GET_REPORTS_LIST_ERROR,
  GET_REPORT_DETAIL,
  GET_REPORT_DETAIL_SUCCESS,
  GET_REPORT_DETAIL_ERROR,
  UPDATE_REPORT_STATUS,
  UPDATE_REPORT_STATUS_SUCCESS,
  UPDATE_REPORT_STATUS_ERROR,
  SET_REPORTS_ACTIVE_TAB,
  SET_REPORTS_SEARCH,
  SET_REPORTS_SORT_FIELD,
  SET_REPORTS_SORT_ORDER,
  SET_REPORTS_PAGE,
} from "./actionTypes";

const initialState = {
  reportsList: [],
  loading: false,
  error: "",
  totalCount: 0,
  totalPages: 0,
  limit: 10,
  page: 1,
  sortOrder: "asc",
  sortField: "",
  search: "",
  activeTab: "needs_review", // "needs_review" or "resolved"
  updateStatusLoading: false,
  reportDetail: null,
  detailLoading: false,
};

const reportsReducer = produce((state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_REPORTS_LIST:
      return {
        ...state,
        loading: true,
      };

    case GET_REPORTS_LIST_SUCCESS:
      return {
        ...state,
        reportsList: payload.data || [],
        totalCount: payload.meta?.totalCount || 0,
        totalPages: payload.meta?.totalPages || 0,
        limit: payload.meta?.limit || 10,
        loading: false,
      };

    case GET_REPORTS_LIST_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    case GET_REPORT_DETAIL:
      return {
        ...state,
        detailLoading: true,
        reportDetail: null,
      };

    case GET_REPORT_DETAIL_SUCCESS:
      return {
        ...state,
        reportDetail: payload.data || null,
        detailLoading: false,
      };

    case GET_REPORT_DETAIL_ERROR:
      return {
        ...state,
        detailLoading: false,
        error: payload,
      };

    case UPDATE_REPORT_STATUS:
      return {
        ...state,
        updateStatusLoading: true,
      };

    case UPDATE_REPORT_STATUS_SUCCESS:
      return {
        ...state,
        updateStatusLoading: false,
      };

    case UPDATE_REPORT_STATUS_ERROR:
      return {
        ...state,
        updateStatusLoading: false,
        error: payload,
      };

    case SET_REPORTS_ACTIVE_TAB:
      return {
        ...state,
        activeTab: payload,
        page: 1,
      };

    case SET_REPORTS_SEARCH:
      return {
        ...state,
        search: payload,
      };

    case SET_REPORTS_SORT_FIELD:
      return {
        ...state,
        sortField: payload,
      };

    case SET_REPORTS_SORT_ORDER:
      return {
        ...state,
        sortOrder: payload,
      };

    case SET_REPORTS_PAGE:
      return {
        ...state,
        page: payload,
      };

    default:
      return state;
  }
});

export default reportsReducer;

